class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    segaraUpdateFreeShippingInNotification(this);

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

async function segaraFetchCartWithRetry(tries = 6, delayMs = 200) {
  for (let i = 0; i < tries; i++) {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();

    // If add-to-cart just happened, item_count/total_price should become > 0 shortly.
    if (cart && (cart.item_count > 0 || cart.total_price > 0)) return cart;

    await new Promise(r => setTimeout(r, delayMs));
  }

  // Last attempt return anyway (even if empty)
  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return res.json();
}
async function segaraFetchCartWithRetry(tries = 8, delayMs = 250) {
  for (let i = 0; i < tries; i++) {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();

    // Wait until cart reflects the add-to-cart
    if (cart && (cart.item_count > 0 || cart.total_price > 0)) return cart;

    await new Promise(r => setTimeout(r, delayMs));
  }

  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  return res.json();
}

async function segaraUpdateFreeShip(root = document) {
  const el = root.querySelector('[data-free-ship]');
  if (!el) return;

  const threshold = parseInt(el.dataset.threshold, 10) || 3500;

  const cart = await segaraFetchCartWithRetry();
  const total = cart.total_price || 0;

  const remaining = Math.max(0, threshold - total);
  const progress = Math.min(100, Math.floor((total / threshold) * 100));

  const currency = cart.currency || 'USD';
  const formattedRemaining = (remaining / 100).toLocaleString(undefined, {
    style: 'currency',
    currency
  });

  const msg = el.querySelector('.segara-free-ship__msg');
  const fill = el.querySelector('[data-free-ship-fill]');

  if (msg) {
    msg.innerHTML = remaining > 0
      ? `<strong>${formattedRemaining}</strong> until free shipping`
      : `<strong>Free shipping unlocked</strong>`;
  }

  if (fill) fill.style.width = `${remaining > 0 ? progress : 100}%`;
}

// Trigger after add-to-cart attempts (covers AJAX timing)
document.addEventListener('click', (e) => {
  if (e.target.closest('button[name="add"], .product-form__submit, form[action*="/cart/add"] button')) {
    setTimeout(() => segaraUpdateFreeShip(document), 300);
    setTimeout(() => segaraUpdateFreeShip(document), 900);
    setTimeout(() => segaraUpdateFreeShip(document), 1600);
  }
});
